import { Flex, Switch, Textarea, Title } from '@mantine/core';

interface BagConditionSectionProps {
	isContaminated: boolean;
	isDamaged: boolean;
	contaminationNotes: string;
	setContaminationNotes: (notes: string) => void;
	onToggleContaminated: () => void;
	onToggleDamaged: () => void;
}

/**
 * Section allowing toggling of bag contamination / damage status
 */
export const BagConditionSection: React.FC<BagConditionSectionProps> = ({
	isContaminated,
	isDamaged,
	onToggleContaminated,
	onToggleDamaged,
	contaminationNotes,
	setContaminationNotes,
}) => {
	return (
		<Flex direction="column" w="100%" gap="sm">
			<Flex px="md" align="center" justify="space-between" w="100%">
				<Title order={2}>Bag Condition</Title>
			</Flex>
			<Flex direction="column" px="md" gap="md">
				<Switch
					label="Contaminated"
					checked={isContaminated}
					onChange={onToggleContaminated}
					size="md"
				/>
				<Switch label="Damaged" checked={isDamaged} onChange={onToggleDamaged} size="md" />
			</Flex>
			{isContaminated && (
				<Flex direction="column" gap="sm" px="md">
					<Title order={2}>Contamination Notes</Title>
					<Textarea
						placeholder="Enter notes here"
						value={contaminationNotes}
						onChange={(e) => setContaminationNotes(e.target.value)}
					/>
				</Flex>
			)}
		</Flex>
	);
};
